var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.managerSuspended
        ? _c("ManagerAccessDeniedWarning")
        : _c(
            "router-view",
            _vm._g(
              _vm._b(
                {
                  attrs: { company: _vm.company, currentUser: _vm.currentUser },
                },
                "router-view",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }